import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { cashdeskSchema } from '../types';

export const createGetCashdeskQuery = () =>
	createAuthQuery({
		params: declareParams<number>(),
		request: {
			method: 'GET',
			url: (id) => `/cashdesk/${id}`,
		},
		response: {
			contract: zodContract(cashdeskSchema),
		},
	});
